import Vue from 'vue'
import axios from 'axios'

const axiosApi = axios.create({
    // baseURL: `http://46.101.244.214:9000/api/`,
    // baseURL: `https://pos2.fatura-app.com/api/`,
    baseURL: `https://elsaka-api.mongz-cashier.com/api/`,
    // baseURL: `http://127.0.0.1:7070/api/`,
    headers: {
        "Access-Control-Allow-Origin": '*',
        Authorization: `Bearer ${window.localStorage.getItem('token')}`
    }
})

axiosApi.interceptors.response.use((response) => {
    return response;
}, (error) => {
    // setTimeout(() => {    
    // }, timeout);
    // if (!error.response) {
    //     alert('NETWORK ERROR')
    // } else {
    const code = error.response.status
    // const response = error.response.data
    if (code === 401) {
        console.log("==================== 401 Unauthorized ===========")
        // localStorage.removeItem("token");
        // localStorage.removeItem("user");
        this.$router.push('/login');
    }

    return Promise.reject(error)
    // }
});
Vue.use(axios)
export default axiosApi;